import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitControlCompleteEditModel } from '@apps-common/types/portal/unit-control'

export const QUERY_KEY_PORTAL_GET_UNIT_CONTROL = (controlId?: number) => ['getUnitControl', controlId].filter(Boolean)

const getUnitControl = async (controlId: number): Promise<IUnitControlCompleteEditModel> =>
  axios.get(`/unitcontrol/getcontrol?controlId=${controlId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitControl

type Props = {
  config?: QueryConfig<QueryFnType>
  controlId: number
}

export const useGetUnitControl = ({ config, controlId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config },
    queryKey: QUERY_KEY_PORTAL_GET_UNIT_CONTROL(controlId),
    queryFn: () => getUnitControl(controlId)
  })
